import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import AutomatedTrafficFineNotificationStep from '../../components/FeaturesComponent/automatedTrafficFineNotificationStep'
import HeaderPartner from '../../components/FeaturesComponent/headerPartner'
import LayoutPartner from '../../components/FeaturesComponent/layoutPartner'
import FixedBottom from '../../components/BasicComponent/FixedBottom'
import BaseButton from '../../components/BasicComponent/BaseButton'
import AutoTrafficFinePayment from './components/autoTrafficFinePayment'
import AutomatedTrafficFineNotificationPaymentInfo from './components/AutomatedTrafficFineNotificationPaymentInfo'
import { number_to_price } from '../../helper/common'
import { PATH } from '../../constants/router'
import {  Modal } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import ModalPaymentQR from '../../components/ModalPaymentQR/ModalPaymentQR'
import LoadingPopup from '../../components/LoadingPopup'
import AutomatedTrafficFineNotificationErrorModal from '../../components/FeaturesComponent/automatedTrafficFineNotificationErrorModal'
import useAutomatedTrafficFineNotificationPayment from '../../hooks/useAutomatedTrafficFineNotificationPayment'
import { useAppParamsContext } from '../../context/AppParamsContext'
import { CURRENT_APP_MODE_CONFIG, IS_TAX_CDS_MODE } from '../../constants/appMode'
import './index.scss'

export default function AutomatedTrafficFineNotificationPayment() {
  const history = useHistory()
  const [sheetVisible, setSheetVisible] = useState(false)

  const { hidePaymentMethod } = useAppParamsContext()
  const {
    isPageLoading,
    vehicles,
    services,
    promotionCode,
    paymentMethod,
    setPaymentMethod,
    isLoadingPromotionCode,
    errorPromotionCode,
    handleChangePromotionCode,
    calculatePaymentWithPromotion,
    paymentCalculated,
    confirmTerm,
    setConfirmTerm,
    handlePayment,
    isSubmitting,
    errorMessage,
    setErrorMessage,
    isOpenQrCodePayment,
    setIsOpenQrCodePayment,
    paymentDetail,
    disabledPayBtn,
    orderDetail
  } = useAutomatedTrafficFineNotificationPayment()

  if (isPageLoading) {
    return <LoadingPopup type="full" noText />
  }

  return (
    <LayoutPartner>
      <HeaderPartner title={CURRENT_APP_MODE_CONFIG.paymentTitle} />
      <div className="AutomatedTrafficFineNotificationPayment">
        <AutomatedTrafficFineNotificationStep step={2} />
        <AutomatedTrafficFineNotificationPaymentInfo
          vehicles={vehicles}
          services={services}
          subTotalAmount={paymentCalculated?.subTotalAmount}
          taxAmount={paymentCalculated?.taxAmount}
          discountAmount={paymentCalculated?.discountAmount}
          usageDate={services[0]?.usageDate}
          totalAmount={paymentCalculated?.totalAmount}
        />
        {!(hidePaymentMethod || orderDetail?.orderId) && (
          <AutoTrafficFinePayment
            promotionCode={promotionCode}
            paymentMethod={paymentMethod}
            setPaymentMethod={setPaymentMethod}
            isLoadingPromotionCode={isLoadingPromotionCode}
            errorPromotionCode={errorPromotionCode}
            calculatePaymentWithPromotion={calculatePaymentWithPromotion}
            handleChangePromotionCode={handleChangePromotionCode}
            paymentCalculated={paymentCalculated}
          />
        )}

        <FixedBottom elementPaddingBottom={'LayoutPartner'}>
          {/* Confirm Terms */}
          {/* {!hidePaymentMethod && (
            <div style={{ marginBottom: '12px' }}>
              <Checkbox checked={confirmTerm} className="Base_Checkbox" onChange={(e) => setConfirmTerm(e.target.checked)}>
                <span>
                  Tôi đã đọc và đồng ý với{' '}
                  <span style={{ color: 'var(--brand-primary)' }} onClick={() => setSheetVisible(true)}>
                    Điều khoản thanh toán
                  </span>
                  .
                </span>
              </Checkbox>
            </div>
          )} */}

          {/* {hidePaymentMethod && (
            <div style={{ marginBottom: '12px' }}>
              <Checkbox 
                checked={autoRenewState.value}
                onChange={(e) => autoRenewState.onChange(e.target.checked)}
                className="auto-renew-checkbox"
              >
                Gia hạn tự động qua ViettelMoney.
              </Checkbox>
            </div>
          )} */}

          <BaseButton onClick={handlePayment} disabled={disabledPayBtn}>
            {isSubmitting ? <LoadingOutlined /> : 'Tiếp theo'}
          </BaseButton>
        </FixedBottom>
      </div>

      <ModalPaymentQR
        open={isOpenQrCodePayment}
        onClose={() => setIsOpenQrCodePayment(false)}
        driver={{
          totalPay: paymentDetail?.totalPayment ?? paymentDetail?.totalAmount ?? 0,
          formatedTotalPay: number_to_price(paymentDetail?.totalPayment ?? paymentDetail?.totalAmount ?? 0),
          qr: paymentDetail,
          expiredInMinutes: 10,
          runTime: new Date()
        }}
        method={paymentDetail?.paymentMethodId}
      />

      <AutomatedTrafficFineNotificationErrorModal
        open={errorMessage}
        onClose={() => {
          setErrorMessage(null)
          history.push(IS_TAX_CDS_MODE ? PATH.TAX_CDS_SMART_ASSISTANT : PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_SERVICES)
        }}
        title={errorMessage?.title || ''}
        content={errorMessage?.content || ''}
      />

      <Modal
        title="Điều khoản thanh toán"
        open={sheetVisible}
        onCancel={() => setSheetVisible(false)}
        footer={[
          <BaseButton key="ok" type="button" onClick={() => setSheetVisible(false)}>
            Đã hiểu
          </BaseButton>
        ]}
        width={600}
        centered>
        <div className="mt-1 mb-2 rules" style={{ fontSize: 14, lineHeight: 1.5, fontWeight: 400, color: 'var(--text-primary)' }}>
          <b>NHỮNG QUY ĐỊNH CHUNG</b>
          <div className="text-bold">1. Phương thức thanh toán và địa điểm thanh toán:</div>
          <div>Phương thức thanh toán bằng chuyển khoản (chuyển khoản ngân hàng hoặc qua ví điện tử Momo).</div>
          <div>
            Các phương thức thanh toán khác (thanh toán bằng tiền mặt, quẹt thẻ/ quẹt post, v.v.). Vui lòng liên hệ bộ phận CSKH để được hỗ trợ thêm.
          </div>
          <div className="text-bold">2. Giá cả và thanh toán:</div>
          <div>Giá của sản phẩm/dịch vụ được quy định rõ ràng.</div>
          <div>Phương thức thanh toán (chuyển khoản ngân hàng, ví điện tử, v.v.).</div>
          <div>Thời hạn thanh toán và các khoản phí phát sinh (nếu có).</div>
          <div className="text-bold">3. Quyền và trách nhiệm của các bên:</div>
          <div>Quyền lợi của người mua, bao gồm quyền khi được nhận đúng với mô tả và chất lượng.</div>
          <div>Trách nhiệm của người mua như cung cấp thông tin chính xác và thanh toán đúng hạn.</div>
          <div>Trách nhiệm của người bán phải đảm bảo quyền lợi và thực hiện đúng với mô tả sản phẩm</div>
          <div className="text-bold">4. Điều khoản về pháp lý:</div>
          <div>Các luật lệ và quy định áp dụng trong hợp đồng mua bán.(Hoá đơn này là 1 phần bằng chứng thể hiện hợp đồng giữa 2 bên)</div>
          <div>Các phương thức giải quyết tranh chấp (hoà giải, trọng tài, toà án, v.v.).</div>
          <div className="text-bold">5. Bảo mật và quyền riêng tư:</div>
          <div>Cam kết của người bán trong việc bảo mật thông tin cá nhân của người mua.</div>
          <div>Quyền truy cập và chỉnh sửa thông tin cá nhân của người mua.</div>
        </div>
      </Modal>
    </LayoutPartner>
  )
}
